export default __webpack_public_path__ + "static/media/52_1_0.4247821f.png";